import CompleteOrderModule from './CompleteOrder.module';

export default CompleteOrderModule;
export * from './CompleteOrderModuleProps';
